import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useParams } from 'react-router-dom';
import VerticalVideoFeed from './VerticalVideoFeed';
import './App.css';

// This is our global video data array.
const videosData = [
    // 2025-02-13
    {
      embedUrl: 'https://www.youtube.com/embed/_8IKYWDPdpw',
      date: '2025-02-13',
      category: 'White House',
    },
    // 2025-02-12
    {
      embedUrl: 'https://www.youtube.com/embed/9QtGNoCbsd8',
      date: '2025-02-12',
      category: 'White House',
    },
    // 2025-02-10
    {
      embedUrl: 'https://www.youtube.com/embed/2jK1cw5WznM',
      date: '2025-02-10',
      category: 'White House',
    },
    // 2025-02-08
    {
      embedUrl: 'https://www.youtube.com/embed/pF7vAmOvtVQ',
      date: '2025-02-08',
      category: 'White House',
    },
    // 2025-02-06
    {
      embedUrl: 'https://www.youtube.com/embed/UWiEODTMBkc',
      date: '2025-02-06',
      category: 'White House',
    },
    // 2024-02-19 (FEMA) x5
    {
      embedUrl: 'https://www.youtube.com/embed/BOLbO41NWY8',
      date: '2024-02-19',
      category: 'FEMA',
    },
    {
      embedUrl: 'https://www.youtube.com/embed/7-UUouCIxKQ',
      date: '2024-02-19',
      category: 'FEMA',
    },
    // 2024-02-18
    {
      embedUrl: 'https://www.youtube.com/embed/3WJF-LC2jbc',
      date: '2024-02-18',
      category: 'House of Representatives',
    },
    // 2024-02-14 (House of Representatives)
    {
      embedUrl: 'https://www.youtube.com/embed/4BgtWSheQJEc',
      date: '2024-02-14',
      category: 'House of Representatives',
    },
    // 2024-02-14 (White House)
    {
      embedUrl: 'https://www.youtube.com/embed/-3qflqMd2tQ',
      date: '2024-02-14',
      category: 'White House',
    },
    // 2024-02-13 (House)
    {
      embedUrl: 'https://www.youtube.com/embed/eET5O2Mm7uk',
      date: '2024-02-13',
      category: 'House of Representatives',
    },
    // 2024-02-13 (White House)
    {
      embedUrl: 'https://www.youtube.com/embed/Zo23Q9JGTcQ',
      date: '2024-02-13',
      category: 'White House',
    },
    // 2024-02-12
    {
      embedUrl: 'https://www.youtube.com/embed/vwZ5sPVoDDk',
      date: '2024-02-12',
      category: 'House of Representatives',
    },
    // 2024-02-11
    {
      embedUrl: 'https://www.youtube.com/embed/eKA-2yMGzto',
      date: '2024-02-11',
      category: 'House of Representatives',
    },
    // 2024-02-06 (White House) x3
    {
      embedUrl: 'https://www.youtube.com/embed/x478DZMLnSM',
      date: '2024-02-06',
      category: 'White House',
    },
    {
      embedUrl: 'https://www.youtube.com/embed/bho5dlf3tbA',
      date: '2024-02-06',
      category: 'White House',
    },
    {
      embedUrl: 'https://www.youtube.com/embed/MoAQd6zvv7k',
      date: '2024-02-06',
      category: 'White House',
    },

];

/**
 * HomePage simply renders the VerticalVideoFeed component
 * with all videos, sorted by date in that component.
 */
function HomePage() {
  return <VerticalVideoFeed videosData={videosData} />;
}

/**
 * CategoryPage filters videos by matching the category slug
 * from the URL. The slug is read from the :categoryName param.
 */
function CategoryPage() {
  const { categoryName } = useParams();

  // Filter out videos whose category slug matches `categoryName`
  const filteredVideos = videosData.filter(
    (video) =>
      video.category.toLowerCase().replace(/\s+/g, '-') === categoryName
  );

  return (
    <div style={{ background: '#1a2e5b', minHeight: '100vh', color: '#fff', padding: '20px' }}>
      <h1>Category: {categoryName}</h1>
      <p>
        <Link to="/" style={{ color: '#61dafb' }}>← Back to Feed</Link>
      </p>

      {filteredVideos.length > 0 ? (
        filteredVideos.map((video, idx) => (
          <div key={idx} style={{ marginBottom: '30px' }}>
            <h3 style={{ margin: '10px 0' }}>
              {video.category} — {new Date(video.date).toLocaleDateString()}
            </h3>
            <iframe
              src={`${video.embedUrl}?autoplay=0&mute=1&controls=1`}
              title={`Category Video ${idx}`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              style={{
                width: '100%',
                maxWidth: '600px',
                height: '315px',
                border: 'none',
                borderRadius: '8px',
                backgroundColor: '#000'
              }}
            />
          </div>
        ))
      ) : (
        <p>No videos found for this category.</p>
      )}
    </div>
  );
}

/**
 * Main App component, setting up routes:
 *   - "/" => HomePage
 *   - "/category/:categoryName" => CategoryPage
 */
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/category/:categoryName" element={<CategoryPage />} />
      </Routes>
    </Router>
  );
}

export default App;